import { useContext } from 'react';

import { ActiveTabContext } from './ActiveTabContext';
import type { ActiveTabContextValue } from './ActiveTabContextValue';

export const useActiveTabContext = (): ActiveTabContextValue => {
	return useContext(ActiveTabContext);
};
